import _ from 'lodash'
import { diff } from '../lib/render-object'

import codeService from 'data/codes'

export const diffif = (props) => {
  if (props.resource !== 'permission') return null
  const codes = codeService.value()
  return () => {
    let {permission: change} = JSON.parse(props.change)
    const diffs = renderPermission(change, codes)

    const atRest = 'Folder Permissions'


    return {diffs, atRest, ...props}
  }
}


function renderPermission(permission, codes) {
  const getFrom = (obj, key, where) => _.get(_.find(obj, where), key)
  const user = (id) => getFrom(codes.users, 'email', {id})
  const usergroup = (id) => getFrom(codes.usergroup, 'code', {id})
  const portfolio = (id) => getFrom(codes.portfolio, 'code', {id})
  const property = (id) => getFrom(codes.property, 'code', {id})
  const remap = (permissions) => _.map(permissions, (permission) => {
    const objectfn = permission.objects.type == 'portfolio' ? portfolio : property
    const userfn = permission.users.type == 'user' ? user : usergroup
    const okey = permission.objects.type == 'portfolio' ? 'Portfolios' : 'Properties'
    const ukey = permission.users.type == 'user' ? 'Users' : 'Usergroups'
    return {
      [okey]: _.map(permission.objects.ids, objectfn),
      [ukey]: _.map(permission.users.ids, userfn),
      role: permission.role
    }
  })

  const [[_old], [_new]] = [remap(permission.old), remap(permission.new)]
  return diff(_old, _new) // diff doesn't handle arrays but permssions new/old is always length 0 or 1.
}